<template>
  <div>
    <b-card>
      <b-row>
        <!-- User Info: Left Col -->

        <b-col
          cols="21"
          xl="6"
          class="d-flex justify-content-between flex-column"
        >
          <!-- User Avatar & Info -->
          <div class="d-flex justify-content-start">
            <b-avatar
              :src="userData.avatar"
              :text="avatarText(userData.name || userData.username)"
              variant="light-primary"
              size="104px"
              rounded
            />
            <div class="d-flex flex-column ml-1">
              <div class="mb-1">
                <h4 class="mb-0">
                  {{ userData.name || userData.username }}
                </h4>
                <span class="card-text">{{ userData.email }}</span>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-card>

    <!-- User Profile Details -->
    <b-card :title="$t('common.details')">
      <b-row v-if="!loading">
        <b-col cols="12" md="4" class="mb-2">
          <h6 class="font-weight-bolder mb-50">{{ $t("common.name") }}:</h6>
          <span>{{ userDetails.name || "-" }}</span>
        </b-col>

        <b-col cols="12" md="4" class="mb-2">
          <h6 class="font-weight-bolder mb-50">{{ $t("operation.email") }}:</h6>
          <span>{{ userDetails.email || "-" }}</span>
        </b-col>

        <b-col cols="12" md="4" class="mb-2">
          <h6 class="font-weight-bolder mb-50">{{ $t("common.phone") }}:</h6>
          <span>{{ userDetails.phone || "-" }}</span>
        </b-col>

        <b-col cols="12" md="4" class="mb-2">
          <h6 class="font-weight-bolder mb-50">
            {{ $t("warehouse.department") }}:
          </h6>
          <span>{{ departmentName || "-" }}</span>
        </b-col>

        <b-col cols="12" md="4" class="mb-2">
          <h6 class="font-weight-bolder mb-50">
            {{ $t("operation.username") }}:
          </h6>
          <span>{{ userDetails.username || "-" }}</span>
        </b-col>

        <b-col cols="12" md="4" class="mb-2">
          <h6 class="font-weight-bolder mb-50">
            {{ $t("common.created_at") }}:
          </h6>
          <span>{{ formatDate(userDetails.created_at) || "-" }}</span>
        </b-col>
      </b-row>

      <template v-if="loading">
        <div class="d-flex justify-content-center mb-1">
          <b-spinner :label="$t('common.loading')" />
        </div>
      </template>
    </b-card>

    <!-- Edit Profile Modal -->
    <b-modal
      id="modal-edit-profile"
      :title="$t('common.edit') + ' ' + $t('common.profile')"
      ok-only
      :ok-title="$t('common.save')"
      size="lg"
      @ok="updateProfile"
    >
      <b-row>
        <b-col cols="12" md="6">
          <b-form-group :label="$t('common.name')">
            <b-form-input
              v-model="editForm.name"
              :placeholder="$t('common.name')"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-group :label="$t('operation.email')">
            <b-form-input
              v-model="editForm.email"
              :placeholder="$t('operation.email')"
              type="email"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-group :label="$t('common.phone')">
            <b-form-input
              v-model="editForm.phone"
              :placeholder="$t('common.phone')"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-group :label="$t('operation.username')">
            <b-form-input
              v-model="editForm.username"
              :placeholder="$t('operation.username')"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>

    <!-- Action Button -->
    <!-- <b-card v-if="!loading">
      <b-button variant="primary" @click="$bvModal.show('modal-edit-profile')">
        {{ $t("common.edit") }} {{ $t("common.profile") }}
      </b-button>
    </b-card> -->
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BAvatar,
  BBadge,
  BButton,
  BFormGroup,
  BFormInput,
  BSpinner,
  BModal,
  BTable,
  BPagination,
} from "bootstrap-vue";
import { avatarText } from "@core/utils/filter";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BAvatar,
    BBadge,
    BButton,
    BFormGroup,
    BFormInput,
    BSpinner,
    BModal,
    BTable,
    BPagination,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("userData")) || {},
      userRoles: JSON.parse(localStorage.getItem("roles")) || [],
      userPermissions: JSON.parse(localStorage.getItem("permissions")) || [],
      userDetails: {},
      loading: true,
      editForm: {
        name: "",
        email: "",
        phone: "",
        username: "",
      },
      avatarText,
      insuranceInvoices: [],
      loadingInvoices: false,
      invoiceFields: [
        {
          key: "invoice_no",
          label: this.$t("common.invoice_no"),
          sortable: true,
        },
        {
          key: "surgery_title",
          label: this.$t("surgery"),
          sortable: true,
        },
        { key: "amount", label: this.$t("common.amount"), sortable: true },
        { key: "status", label: this.$t("common.status"), sortable: true },
        {
          key: "created_at",
          label: this.$t("common.created_at"),
          sortable: true,
        },
        { key: "actions", label: this.$t("common.actions") },
      ],
      currentPage: 1,
      perPage: 15,
      totalRows: 0,
    };
  },
  computed: {
    departmentName() {
      if (
        this.userDetails.departments &&
        this.userDetails.departments.length > 0
      ) {
        return this.userDetails.departments[0].name;
      }
      return null;
    },
  },
  mounted() {
    this.getUserDetails();
    // this.getInsuranceInvoices();
  },
  methods: {
    async getUserDetails() {
      this.loading = true;
      try {
        await this.getList(
          `/user/${this.userData.id}?include=departments,roles`
        );

        if (this.all_data) {
          this.userDetails = this.all_data;
          this.editForm = {
            name: this.userDetails.name,
            email: this.userDetails.email,
            phone: this.userDetails.phone || "",
            username: this.userDetails.username,
          };
        }
      } catch (error) {
        console.error("Error fetching user details:", error);
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Error",
            variant: "danger",
            text: "Failed to load user details",
          },
        });
      } finally {
        this.loading = false;
      }
    },
    async updateProfile() {
      try {
        const params = {
          form: {
            ...this.editForm,
            _method: "PUT",
          },
          path: `/user/${this.userData.id}`,
        };

        await this.update(params);

        // Update localStorage
        const updatedUserData = {
          ...this.userData,
          name: this.editForm.name,
          email: this.editForm.email,
          username: this.editForm.username,
        };
        localStorage.setItem("userData", JSON.stringify(updatedUserData));
        this.userData = updatedUserData;

        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Success",
            variant: "success",
            text: "Profile updated successfully",
          },
        });

        this.getUserDetails();
      } catch (error) {
        console.error("Error updating profile:", error);
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Error",
            variant: "danger",
            text: "Failed to update profile",
          },
        });
      }
    },
    formatDate(date) {
      if (!date) return "-";
      return new Date(date).toLocaleDateString();
    },
    formatCurrency(amount) {
      if (!amount) return "-";
      return new Intl.NumberFormat("en-US", {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(amount);
    },
    async getInsuranceInvoices(page = 1) {
      this.loadingInvoices = true;
      try {
        await this.getList(`/myInsuranceInvoices?page=${page}`);

        if (this.all_data) {
          // Handle paginated response
          if (this.all_data.data && Array.isArray(this.all_data.data)) {
            this.insuranceInvoices = this.all_data.data;
            this.totalRows = this.all_data.total || 0;
            this.currentPage = this.all_data.current_page || 1;
            this.perPage = this.all_data.per_page || 15;
          } else if (Array.isArray(this.all_data)) {
            this.insuranceInvoices = this.all_data;
            this.totalRows = this.all_data.length;
          }
        }
      } catch (error) {
        console.error("Error fetching insurance invoices:", error);
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: this.$t("common.error"),
            variant: "danger",
            text: this.$t("common.failed_to_load_data"),
          },
        });
      } finally {
        this.loadingInvoices = false;
      }
    },
    onPageChange(page) {
      // this.getInsuranceInvoices(page);
    },
    getStatusVariant(status) {
      const statusMap = {
        pending: "warning",
        approved: "success",
        printed: "info",
        rejected: "danger",
      };
      return statusMap[status] || "secondary";
    },
    async printInvoice(invoiceId) {
      try {
        const params = {
          form: {
            _method: "PUT",
          },
          path: `/myInsuranceInvoices/${invoiceId}/print`,
        };

        await this.update(params);

        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: this.$t("common.success"),
            variant: "success",
            text: this.$t("common.printed_successfully"),
          },
        });

        // Refresh the current page after printing
        // this.getInsuranceInvoices(this.currentPage);
      } catch (error) {
        console.error("Error printing invoice:", error);
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: this.$t("common.error"),
            variant: "danger",
            text: this.$t("common.print_failed"),
          },
        });
      }
    },
  },
};
</script>

<style scoped>
.card-text {
  color: #6e6b7b;
}
</style>
